import { render } from "./formStructure.vue?vue&type=template&id=48d66d96"
import script from "./formStructure.vue?vue&type=script&lang=js"
export * from "./formStructure.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__